/* eslint @typescript-eslint/no-unsafe-assignment: 0 */
/* eslint @typescript-eslint/no-unsafe-return: 0 */

import axios from 'axios'
import { Component } from 'vue-property-decorator'
import { DEFAULT_PER_PAGE } from '@/helpers/enums/params'
import { Options } from './createCRUDModuleMixin'
import { ListMixin } from './createListMixin'


type MapUnknown = Record<string, unknown>

const DEFAULT_PARAMS = {
  page: 1,
  per_page: DEFAULT_PER_PAGE,
  passport_type: 'school',
  is_active: true,
}


@Component
export class PassportListMixin extends ListMixin {
  public async asyncData(isLoading = true) {
    this.cancelTokenSource?.cancel()
    this.cancelTokenSource = axios.CancelToken.source()
    const cancelToken = this.cancelTokenSource.token
    const query = this.disabledPaginationQuery ? {} : this.$route.query

    const payload = {
      ...DEFAULT_PARAMS,
      ...query,
      ...this.filters,
    }

    const options = {
      payload,
      cancelToken,
      ...this.defaultParams,
    }

    this.isLoadingAsyncData = isLoading

    try {
      await this.getAll(options)
    } finally {
      this.isLoadingAsyncData = false
    }
  }
}

export const createPassportListMixin = <T extends MapUnknown = MapUnknown>({ Model, StoreModule }: Options<T>) => ({
  mixins: [PassportListMixin],
  data: () => ({ Model, StoreModule }),
})
